<template>
    <div class="container">
      <div class="myScore">
        <!-- <div class="fr scoreDetail" @click="toScoreDetail()">明细</div>
        <div class="score">
          <img class="score_img" src="../assets/images/score_bg.png" alt="">
          <span>{{scoreInfo.score}}</span>
        </div>
        <div class="scoreBtn" :class="{'signed': scoreInfo.sign_status == 1}" @click="toSign(scoreInfo.sign_status)">{{scoreInfo.sign_status == 1 ? '今日已签到，明天再来吧～' : '签到'}}</div> -->
        <div class="flex-row-bc">
          <div>
            <div class="fs-32 fw-bold flex-row-sc">
              我的蟠桃
              <span class="detail" @click="toScoreDetail()">明细</span>
            </div>
            <div class="fw-bold" style="font-size: .96rem;padding: .15rem 0">{{scoreInfo.score}}</div>
            <!-- <div class="fs-14 fw-bold">相当于<text class="fc-red">{{scoreInfo.price}}</text>元</div> -->
          </div>
          <img :src="scoreInfo.icon" mode="widthFix" style="width: 2rem;margin-right:.56rem" />
          <div class="rules" @click="toRules()">说明</div>
        </div>
      </div>
      <!-- 签到列表 -->
      <div class="card">
        <div class="card-tit">{{userSignInfo.title}}</div>
        <div class="sign-list flex-row-bc">
          <div class="item flex-colum-cc" v-for="(item,index) in userSignInfo.signList" :key="index">
            <div @click="toSign(item.is_today_sign)" style="width: 100%;height: 100%;">
              <img :src="item.img" style="width: 100%;" />
              <div class="tips" :style="{color: item.text_color}" v-if="item.is_today_sign === 0">{{item.tips}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 任务列表 -->
      <div class="card" v-if="taskInfo.rookieTaskList">
        <div class="card-tit" v-if="taskInfo.rookieTaskList.title">
          {{ taskInfo.rookieTaskList.title }}
        </div>
        <div class="task-list">
          <div class="item flex-row-bc" v-for="(item,index) in taskInfo.rookieTaskList.list" :key="index">
            <div class="flex-row-sc">
              <div class="img">
                <img :src="item.icon" style="width: 100%;" />
                <span class="score">+{{item.score}}</span>
              </div>
              <div class="info">
                <div class="fs-28 fw-bold" v-if="item.complete_status == 3">{{item.title}}(仅限俺来也APP)</div>
                <div class="fs-28 fw-bold" v-else>{{item.title}}</div>
                <div class="fs-20 fc-666 marginT14">{{item.des}}</div>
              </div>
            </div>
            <div class="btns">
              <div class="btn" v-if="item.complete_status == 1" @click="makeScore(item)">做任务</div>
              <div class="btn completed" v-else-if="item.complete_status == 2">已完成</div>
              <div class="btn" v-else-if="item.complete_status == 3"><a style="color: #2F2F2F" href="https://dl.anlaiye.com">下载APP</a></div>
            </div>
          </div>
        </div>
      </div>
      <div class="card" v-if="taskInfo.dailyTaskList">
        <div class="card-tit" v-if="taskInfo.dailyTaskList.title">
          {{ taskInfo.dailyTaskList.title }}
        </div>
        <div class="task-list">
          <div class="item flex-row-bc" v-for="(item,index) in taskInfo.dailyTaskList.list" :key="index">
            <div class="flex-row-sc">
              <div class="img">
                <img :src="item.icon" style="width: 100%;" />
                <span class="score">+{{item.score}}</span>
              </div>
              <div class="info">
                <div class="fs-28 fw-bold" v-if="item.complete_status == 3">{{item.title}}(仅限俺来也APP)</div>
                <div class="fs-28 fw-bold" v-else>{{item.title}}</div>
                <div class="fs-20 fc-666 marginT14">{{item.des}}</div>
              </div>
            </div>
            <div class="btns">
              <div class="btn" v-if="item.complete_status == 1" @click="makeScore(item)">做任务</div>
              <div class="btn completed" v-else-if="item.complete_status == 2">已完成</div>
              <div class="btn" v-else-if="item.complete_status == 3"><a style="color: #2F2F2F" href="https://dl.anlaiye.com">下载APP</a></div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="scoreList">
        <span class="tit">轻松赚积分</span>
        <div class="score-item" v-for="item in scoreList" :key="item.id">
          <div class="score-des">
            <img class="item-img" :src="item.icon">
            <div class="tit-box">
              <div class="title">{{item.title}}</div>
              <div class="des" v-html="item.des"></div>
            </div>
          </div>
          <div class="item-btn" v-if="item.complete_status == 1" @click="makeScore(item)">去完成</div>
          <div class="item-btn signed" v-if="item.complete_status == 2">已完成</div>
          <div class="item-btn" v-if="item.complete_status == 3"><a style="color: #2F2F2F" href="https://dl.anlaiye.com">下载APP</a></div>
        </div>
      </div> -->
      <!--签到成功弹窗-->
      <div class="mask-box" v-if="showMask" @click="showMask = false" @touchmove.prevent>
        <div class="mask">
          <!-- <img src="../assets/images/close-btn02.png" class="mask-close" @click="showMask = false">
          <div class="mask-tit">
            <img class="mask-icon" src="../assets/images/score_bg.png" alt="">
            <span>+{{signedInfo.score}}</span>
          </div> -->
          <div class="ac fs-42">{{signedInfo.msg}}</div>
          <img :src="signedInfo.img" style="width: 90%;margin: 0 auto" alt="">
          <div class="btn" style="width: 100%;margin:0;height: 1rem;line-height: 1rem;font-size: .4rem;font-weight: bold;border-radius: .24rem;padding:0">开心收下</div>
        </div>
      </div>
      <!--赚积分弹窗-->
      <div class="mask-box" @click="showMakeScore = false" v-if="showMakeScore" @touchmove.prevent>
        <div class="mask">
          <img src="../assets/images/close-btn02.png" class="mask-close" @click="showMakeScore = false">
          <div class="tips">{{makeScoreInfo.tips}}</div>
          <div class="btn" @click="showMakeScore = false">知道了</div>
        </div>
      </div>
    </div>
</template>

<script>
    import {actions} from "../store/actions";

    export default {
      name: "myScore",
      data() {
        return {
          scoreList: [],
          scoreInfo: {},
          showMask: false,
          signedInfo: {},
          showMakeScore: false,
          makeScoreInfo: {},
          userSignInfo: {},
          taskInfo: {}
        }
      },
      created() {
        this.getScoreInfo();
        this.getScoreList();
      },
      methods: {
        getScoreInfo() {
          let _this = this
          actions.getMyScore(_this, {uid: _this.$store.state.wxUid}, function (res) {
            _this.scoreInfo = res;
          },function(){})
          actions.getUserSignList(_this, {uid: _this.$store.state.wxUid}, function (res) {
            _this.userSignInfo = res;
          },function(){})
        },
        getScoreList() {
          let _this = this
          actions.getScoreListNew(_this, {uid: _this.$store.state.wxUid}, function (res) {
            _this.taskInfo = res;
          },function(){})
        },
        toScoreDetail() {
          this.$router.push({name:'ScoreDetail'})
        },
        toSign(status) {
          if(status === 0) {
            return
          }
          let _this = this
          let params = {
            uid:  _this.$store.state.wxUid,
            school_id: _this.$store.state.schoolInfo.schoolId,
            school_name: _this.$store.state.schoolInfo.schoolName,
            mp_encryption: this.$utils.Encrypt(_this.$store.state.userInfo.mp_real)
          }
          actions.userSign(_this, params, function (res) {
            _this.signedInfo = res;
            _this.showMask = true;
            _this.getScoreInfo();
          },function(res){
            _this.showMask = false;
            _this.$messagebox.alert(res.body.message, '')
          })
        },
        makeScore(item) {
          // this.showMakeScore = true;
          // this.makeScoreInfo = item;
          if(item.jump_type == 500077){
            this.$router.push({name:'OrderList'})
          }else{
            this.$router.push({name:'TagPage'})
          }
        },
        toRules() {
          location.href = 'https://special.anlaiye.com/theme/v1/h5/protocol/alyScore1.html';
        }
      }
    }
</script>

<style scoped>
.container {
  padding: .24rem;
  padding-bottom: 1.5rem;
  background: linear-gradient(180deg, #FDEC78 0%, rgba(255, 255, 255, 0) 10%);
}

.myScore {
  position: relative;
  padding: .24rem;
  background: linear-gradient(135deg, #FDE958 0%, #FED400 100%);
  border-radius: .2rem;
}

.myScore .detail {
  height: .32rem;
  line-height: .32rem;
  background: #FCED82;
  border-radius: .16rem;
  font-size: .2rem;
  color: #722F02;
  padding: 0 .08rem;
  margin-left: .1rem;
}

.myScore .rules{
  position: absolute;
  right: .24rem;
  top: .24rem;
}

.card {
  background: #FFFFFF;
  border-radius: .2rem;
  padding: .2rem;
  margin-top: .2rem;
}

.card .card-tit {
  font-size: .32rem;
  font-weight: bold;
  margin-bottom: .24rem;
}

.card .card-tit span {
  font-size: .2rem;
  color: #666666;
  font-weight: normal;
}

.sign-list .item {
  position: relative;
  width: .8rem;
  height: 1.08rem;
  text-align: center;
  border-radius: .08rem;
}

.sign-list .item.is-sign {
  /* background: #FFCD40; */
  opacity: 0.1;
}

.sign-list .item .tips {
  position: absolute;
  font-size: .2rem;
  color: #FF8A1F;
  margin: 0;
  bottom: .08rem;
  left: 0;
  width: 100%;
  text-align: center;
}

.task-list .item {
  margin-bottom: .4rem;
}

.task-list .item:last-child{
  margin-bottom: 0;
}

.task-list .item .img {
  position: relative;
  width: 1rem;
  height: 1rem;
  margin-right: .16rem;
}

.task-list .item .img .score{
  position: absolute;
  font-size: .2rem;
  color: #FF8A1F;
  bottom: .1rem;
  left: 0;
  width: 100%;
  text-align: center;
}

.task-list .item .btn {
  border-radius: .3rem;
  font-size: .24rem;
  font-weight: bold;
  width: 1.32rem;
  height: .6rem;
  line-height: .6rem;
  text-align: center;
  background: linear-gradient(135deg, #FFEC00 0%, #FED400 100%);
  padding: 0;
}

.task-list .item .btn.completed {
  background: #ccc;
  color: #fff;
}

.mask-box {
  background: rgba(0, 0, 0, 0.50);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1002;
}

.mask-box .mask {
  left: 50%;
  top: 20%;
  margin-left: -3.2rem;
  /* margin-top: -310rpx; */
  width: 6.4rem;
  /* height: 620rpx; */
  height: auto;
  background: #FFFFFF;
  border-radius: .24rem;
  overflow: hidden;
  padding: .6rem .3rem;
  text-align: center;
}

.mask-box .mask-close {
  width: .24rem;
  height: .24rem;
  margin-top: .3rem;
  margin-right: .3rem;
  float: right;
}

.mask-box .mask-tit {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: .6rem;
  margin-bottom: .15rem;
}

.mask-box .signed-score {
  color: #FF9E00;
  font-size: .48rem;
}

.mask-box .mask-icon {
  width: .42rem;
  height: .45rem;
  margin-right: .05rem;
}

.mask-box .mask-score {
  font-size: .36rem;
  color: #707070;
}

.mask-box .tips {
  font-size: .36rem;
  color: #4C4C4C;
  margin: .71rem .62rem .22rem;
  text-align: center;
}

.mask-box .btn {
  background: #FFDF00;
  border-radius: .36rem;
  width: 2.84rem;
  height: .72rem;
  line-height: .72rem;
  font-size: .28rem;
  color: #2F2F2F;
  text-align: center;
  margin-left: 1.18rem;
}
</style>



// WEBPACK FOOTER //
// myScore.vue?6154bcb6